/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import TextContainer from "../../../../components/Container/TextContainer";
import Layout from "../../../Layouts/Layout";
import guidebookOverviewPageStyle from "../../Generic/GenericGuidebookPage/guidebookOverviewPageStyle";
import CardLinked from "../../../../components/Cards/CardLinked/CardLinked";
import * as guidebookSettlementContent from "./GuidebookSettlementCardContent";
import Grid from "@mui/material/Grid";
import { Helmet } from "react-helmet-async";
import Container from "../../../../components/Container/Container";
import Typography from "@mui/material/Typography";
import { gaSet } from "../../../../services/googleAnalyticsService";

export default function GuidebookEmploymentLawOverview() {
  const title = "Ratgeber Kündigung | Legalbird";
  gaSet({ title: title });

  return (
    <Layout backgroundType={"serviceworld"}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Container>
        <Typography variant={"h1"} sx={guidebookOverviewPageStyle.overviewHeading}>
          Ratgeber Arbeitsrecht
        </Typography>
      </Container>
      <TextContainer>
        <Grid container spacing={5} sx={{
          alignItems: "stretch"
        }}>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookSettlementContent.guidebookSettlementCalculation.linkTo}
              image={guidebookSettlementContent.guidebookSettlementCalculation.image}
              headline={guidebookSettlementContent.guidebookSettlementCalculation.headline}
              text={guidebookSettlementContent.guidebookSettlementCalculation.text}
              altTitle={guidebookSettlementContent.guidebookSettlementCalculation.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookSettlementContent.guidebookSettlementProcedure.linkTo}
              image={guidebookSettlementContent.guidebookSettlementProcedure.image}
              headline={guidebookSettlementContent.guidebookSettlementProcedure.headline}
              text={guidebookSettlementContent.guidebookSettlementProcedure.text}
              altTitle={guidebookSettlementContent.guidebookSettlementProcedure.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookSettlementContent.guidebookSettlementCosts.linkTo}
              image={guidebookSettlementContent.guidebookSettlementCosts.image}
              headline={guidebookSettlementContent.guidebookSettlementCosts.headline}
              text={guidebookSettlementContent.guidebookSettlementCosts.text}
              altTitle={guidebookSettlementContent.guidebookSettlementCosts.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookSettlementContent.guidebookKindsOfNotices.linkTo}
              image={guidebookSettlementContent.guidebookKindsOfNotices.image}
              headline={guidebookSettlementContent.guidebookKindsOfNotices.headline}
              text={guidebookSettlementContent.guidebookKindsOfNotices.text}
              altTitle={guidebookSettlementContent.guidebookKindsOfNotices.altTitle}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <CardLinked
              linkTo={guidebookSettlementContent.guidebookSettlementTax.linkTo}
              image={guidebookSettlementContent.guidebookSettlementTax.image}
              headline={guidebookSettlementContent.guidebookSettlementTax.headline}
              text={guidebookSettlementContent.guidebookSettlementTax.text}
              altTitle={guidebookSettlementContent.guidebookSettlementTax.altTitle}
            />
          </Grid>
        </Grid>
        <br />
      </TextContainer>
    </Layout>
  );
};
